import {useEffect, useState} from "react";

interface MaybeFunction<T> {
    (): Promise<T>
}

type Maybe<T> = MaybeFunction<T> | Promise<T>

export function useAsyncMemo<T>(maybe: Maybe<T>): T | undefined {
    const [result, setResult] = useState<T>();

    useEffect(() => {
        const promise: Promise<T> = typeof maybe === "function" ? maybe() : maybe
        promise.then(setResult)
    }, [maybe])

    return result
}